export enum OperatorInformationType {
  OPERATOR_TYPE = "id",
  NAME = "name",
  OPERATOR_RARITY = "operatorRarity",
  OPERATOR_CLASS_TYPE = "operatorClassType",
  ELEMENT_TYPE = "elementType",
  WEAPON_TYPE = "weaponType",
  MAIN_ATTRIBUTE_TYPE = "mainAttributeType",
  SECONDARY_ATTRIBUTE_TYPE = "secondaryAttributeType",
  POTENTIALS = "potentials",
  ALL_LEVELS = "allLevels",
}

export enum OperatorClassType {
  GUARD = "GUARD",
  CASTER = "CASTER",
  STRIKER = "STRIKER",
  VANGUARD = "VANGUARD",
  DEFENDER = "DEFENDER",
  SUPPORTER = "SUPPORTER",
}
